import React from 'react';
import { MessageCircle } from 'lucide-react';
import { openWhatsApp, WA_MAIN } from '../mock';

const Hero = () => {
  const handleWhatsApp = () => {
    openWhatsApp(
      WA_MAIN,
      'Hola, quisiera hacer una consulta legal.',
      'hero-cta'
    );
  };

  return (
    <section className="hero-section" id="inicio">
      <div className="hero-container hero-container-single">
        <div className="hero-content">
          <div className="hero-brand">
            <p className="hero-brand-name">
              <span className="brand-line">SAMPELLEGRINI</span>
              <span className="brand-line brand-amp">&</span>
              <span className="brand-line">JALIFF</span>
            </p>
            <p className="hero-brand-tagline">Abogacía humana, soluciones reales</p>
            <div className="hero-brand-divider"></div>
          </div>
          <h1 className="hero-title">
            Abogadas especialistas en familia, sucesiones y laboral y ART.
          </h1>
          <p className="hero-highlight" data-testid="hero-highlight">
            Tu problema legal, resuelto con trato cercano.
          </p>
          <p className="hero-subtitle">
            Estudio jurídico familiar. Te explicamos tu caso con claridad y lo seguimos de cerca, de principio a fin.
          </p>

          <button
            type="button"
            onClick={handleWhatsApp}
            className="hero-whatsapp-cta"
            data-action="whatsapp-click"
            data-wa-label="hero-cta"
            data-testid="hero-whatsapp-cta"
          >
            <MessageCircle className="w-5 h-5" strokeWidth={2.2} />
            <span>Hacé tu consulta por WhatsApp</span>
          </button>

          <div className="hero-trust-indicators" data-testid="hero-trust">
            <div className="trust-item">
              <p className="trust-number">29</p>
              <p className="trust-label">Años de experiencia combinada</p>
            </div>
            <div className="trust-divider"></div>
            <div className="trust-item">
              <p className="trust-value-prop">Atención personalizada</p>
              <p className="trust-label">y seguimiento directo de tu caso</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
